import { configureStore } from "@reduxjs/toolkit";

import globalReducer from "./actions/globalSlice/globalSlice";
import searchReducer from "./actions/searchSlice/searchSlice";

export const store = configureStore({
  reducer: {
    global: globalReducer,
    search: searchReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
